import { getNowBusinessDateString } from '@/helpers/dateHelper'
import { useAppStore } from '@/store/app'
import {
  PaginatedProductVariants,
  ProductVariantDownloadFilter,
  ProductVariantFilter
} from '@/types/productVariants'
import BaseService from './baseService'
import EndPoints from '@/constants/dxApiEndpoints'

class ProductVariantService extends BaseService {
  getProductVariant = async (
    businessProfileId: number,
    catalogId: number,
    filterParameters: ProductVariantFilter
  ): Promise<PaginatedProductVariants> => {
    const response = await this.apiClient.post<{
      data: PaginatedProductVariants
    }>(
      EndPoints.SearchFilteredProductVariants(businessProfileId, catalogId),
      filterParameters
    )
    return response.data
  }
  downloadProductVariant = async (
    businessProfileId: number,
    catalogId: number,
    filterParameters: ProductVariantDownloadFilter
  ): Promise<void> => {
    const response = await this.apiClient.post(
      EndPoints.downloadProductVariants(businessProfileId, catalogId),
      filterParameters,
      {
        responseType: 'blob'
      }
    )
    const blob = new Blob([response as BlobPart], { type: 'text/csv' })

    // Default filename if backend doesn't set one
    const offset = useAppStore().getSelectedBusinessProfileTimezone?.offset ?? 0
    const fileName = `productVariants_${getNowBusinessDateString(offset)}.csv`
    // Trigger browser download
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  }
}

export default ProductVariantService
